import { render, staticRenderFns } from "./lobby.vue?vue&type=template&id=163d8c74&scoped=true&"
import script from "./lobby.ts?vue&type=script&lang=ts&"
export * from "./lobby.ts?vue&type=script&lang=ts&"
import style0 from "./lobby.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./lobby.vue?vue&type=style&index=1&id=163d8c74&lang=stylus&scoped=true&"
import style2 from "./lobby.vue?vue&type=style&index=2&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d8c74",
  null
  
)

export default component.exports